var chunkMapping = {
	"636": [
		74127,
		35271,
		50330
	],
	"1697": [
		1697
	],
	"5711": [
		75711
	],
	"6921": [
		66921
	],
	"7343": [
		77343
	],
	"9166": [
		29166
	]
};
var idToExternalAndNameMapping = {
	"1697": [
		"default",
		"./generic/elements/form",
		71305
	],
	"29166": [
		"default",
		"./generic/elements/divider",
		71305
	],
	"35271": [
		"default",
		"./generic/elements/icons",
		71305
	],
	"50330": [
		"default",
		"./generic/components/general/toast",
		71305
	],
	"66921": [
		"default",
		"./generic/elements/loading",
		71305
	],
	"74127": [
		"default",
		"./generic/elements/cms-picture",
		71305
	],
	"75711": [
		"default",
		"./generic/elements/info-block",
		71305
	],
	"77343": [
		"default",
		"./generic/elements/button",
		71305
	]
};
var idToRemoteMap = {
	"1697": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"29166": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"35271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"50330": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"66921": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"74127": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"75711": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"77343": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"1697": {
		"shareScope": "default",
		"name": "./generic/elements/form",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"29166": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"35271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"50330": {
		"shareScope": "default",
		"name": "./generic/components/general/toast",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"66921": {
		"shareScope": "default",
		"name": "./generic/elements/loading",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"74127": {
		"shareScope": "default",
		"name": "./generic/elements/cms-picture",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"75711": {
		"shareScope": "default",
		"name": "./generic/elements/info-block",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"77343": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 71305,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}